import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { CaptchaComponent } from './captcha/captcha.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormSubmittedComponent } from './components/form-submitted/form-submitted.component';
import { ModalModule } from './components/modal/modal.module';

import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    CaptchaComponent,
    FormSubmittedComponent,
    FooterComponent,
    DisclaimerComponent,
  ],
  imports: [
    CommonModule,
    CarouselModule,
    HttpClientModule,
    RouterModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    CarouselModule,
    HttpClientModule,
    FormsModule,
    ModalModule,
    ReactiveFormsModule,
    CaptchaComponent,
    FormSubmittedComponent,
    FooterComponent,
    DisclaimerComponent,
  ],
})
export class SharedModule {}
